var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAreaChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6 12.9596L8.5425 9.46459C8.79 9.11959 9.2775 9.05209 9.6075 9.31459L15.75 14.0846V14.4596C15.75 14.8721 15.4125 15.2096 15 15.2096H3C2.5875 15.2096 2.25 14.8721 2.25 14.4596V10.1696C2.415 10.1696 2.58 10.2221 2.715 10.3346L6 12.9596ZM2.25 8.45959C2.58 8.45959 2.91 8.57209 3.1875 8.78959L5.715 10.8071L7.7925 7.94959C8.2875 7.26709 9.255 7.12459 9.93 7.64959L15.75 12.1871V6.20959C15.75 5.79709 15.4125 5.45959 15 5.45959H12.75L9.615 2.95459C9.2775 2.68459 8.79 2.75209 8.535 3.10459L5.25 7.70959L2.7 5.79709C2.565 5.69959 2.4075 5.64709 2.25 5.64709V8.45959Z",
    fill: "#002D62"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAreaChart);
export default __webpack_public_path__ + "static/media/area_chart.38d6baec02ce606dce9ee13493da7d37.svg";
export { ForwardRef as ReactComponent };